export default {
  lineNumberColor: `#DCDCDC`,
  lineNumberBgColor: `#1E1E1E`,
  backgroundColor: `#1E1E1E`,
  textColor: `#DCDCDC`,
  substringColor: `#DCDCDC`,
  keywordColor: `#569CD6`,
  attributeColor: `#9CDCFE`,
  selectorAttributeColor: `#D7BA7D`,
  docTagColor: `#608B4E`,
  nameColor: `#569CD6`,
  builtInColor: `#4EC9B0`,
  literalColor: `#569CD6`,
  bulletColor: `#D7BA7D`,
  codeColor: `#DCDCDC`,
  additionColor: undefined,
  regexpColor: `#9A5334`,
  symbolColor: `#569CD6`,
  variableColor: `#BD63C5`,
  templateVariableColor: `#BD63C5`,
  linkColor: `#569CD6`,
  selectorClassColor: `#D7BA7D`,
  typeColor: `#4EC9B0`,
  stringColor: `#D69D85`,
  selectorIdColor: `#D7BA7D`,
  quoteColor: `#57A64A`,
  templateTagColor: `#9A5334`,
  deletionColor: undefined,
  titleColor: `#DCDCDC`,
  sectionColor: `gold`,
  commentColor: `#57A64A`,
  metaKeywordColor: `#9B9B9B`,
  metaColor: `#9B9B9B`,
  functionColor: `#DCDCDC`,
  numberColor: `#B8D7A3`,
}
